import './components/lang';
import './components/scroll';
import './components/swiper';
